import React from "react";
import { ArrowLeft } from "lucide-react";
import { BagLogo } from "../components/Logo";

const S = ({ n, title, children }) => (
  <section className="mt-6" data-testid={`terms-section-${n}`}>
    <h2 className="font-display font-black text-lg text-slate-900">{n}. {title}</h2>
    <div className="mt-2 space-y-2 text-sm text-slate-600 leading-relaxed whitespace-pre-line">{children}</div>
  </section>
);

export default function LegalTerms() {
  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <div className="max-w-2xl mx-auto bg-white min-h-screen shadow-2xl px-6 py-8" data-testid="terms-page">
        <div className="flex items-center gap-3">
          <button data-testid="legal-back" onClick={() => (window.history.length > 1 ? window.history.back() : window.location.assign("/"))} className="bg-slate-100 rounded-full p-2 active:scale-95 transition-transform"><ArrowLeft size={18} /></button>
          <a href="/" className="flex items-center gap-2 text-brand-red font-display font-bold"><BagLogo size={28} /> Ponesi</a>
        </div>
        <h1 className="font-display font-black text-2xl sm:text-3xl text-slate-900 mt-5">Uslovi korišćenja platforme Ponesi</h1>
        <p className="text-xs text-slate-400 mt-1">Verzija 1.0</p>

        <S n="1" title="OSNOVNE INFORMACIJE">{`Internet platformom Ponesi, dostupnom na adresi ponesi.rs, upravlja:

Sahara Group DOO
Masarikov Trg 18
16000 Leskovac, Republika Srbija
PIB: 115572837
Matični broj: 22177460
Email: privacy@ponesi.rs

U daljem tekstu: „Ponesi“.

Ovim Uslovima korišćenja uređuju se prava i obaveze korisnika prilikom korišćenja platforme Ponesi.

Kreiranjem korisničkog naloga i prihvatanjem ovih Uslova korisnik potvrđuje da je Uslove pročitao, razumeo i prihvatio.`}</S>

        <S n="2" title="O PLATFORMI PONESI">{`Ponesi je digitalna platforma koja omogućava korisnicima da pronađu ugostiteljske objekte, pregledaju njihovu ponudu, kreiraju porudžbinu i lično preuzmu poručenu hranu ili druge proizvode u izabranom objektu.

Ponesi nije servis za dostavu.

Osim ako nije izričito navedeno drugačije, Ponesi ne priprema hranu i nije proizvođač proizvoda koje nude restorani.

Ponesi omogućava elektronsko povezivanje korisnika i restorana i tehničku obradu porudžbine.

Restoran je odgovoran za pripremu hrane, kvalitet proizvoda, bezbednost hrane, informacije o sastojcima i alergenima, raspoloživost proizvoda, izdavanje fiskalne dokumentacije kada je primenljivo i izvršenje prihvaćene porudžbine u skladu sa važećim propisima.`}</S>

        <S n="3" title="KORISNIČKI NALOG">{`Za korišćenje određenih funkcija Ponesi-ja korisnik može biti dužan da kreira korisnički nalog.

Korisnik je odgovoran za tačnost podataka koje dostavi i za čuvanje pristupa svom nalogu.

Ponesi može zahtevati verifikaciju email adrese pre omogućavanja kreiranja porudžbine.

Korisniku nije dozvoljeno da neovlašćeno koristi nalog drugog lica.`}</S>

        <S n="4" title="KREIRANJE PORUDŽBINE">{`Korisnik bira restoran, proizvode, opcije proizvoda, količine i željeno vreme preuzimanja.

Slanjem porudžbine korisnik restoranu upućuje zahtev za pripremu odabrane porudžbine.

Porudžbina se smatra prihvaćenom kada restoran potvrdi porudžbinu putem sistema Ponesi.

Dok restoran ne odgovori, korisniku se prikazuje obaveštenje:

„Molimo vas ne napuštajte stranicu dok restoran ne prihvati vašu porudžbinu. Hvala.“

Restoran može:
- prihvatiti traženo vreme preuzimanja;
- predložiti drugo vreme preuzimanja;
- odbiti porudžbinu.`}</S>

        <S n="5" title="PROMENA VREMENA PREUZIMANJA">{`Ako restoran predloži drugo vreme preuzimanja, korisnik dobija ograničen rok, koji je trenutno 60 sekundi, da prihvati predloženo vreme ili otkaže porudžbinu.

Rok se računa na osnovu serverskog vremena sistema Ponesi, a ne na osnovu vremena podešenog na uređaju korisnika.

Ako korisnik ne odgovori u predviđenom roku, sistem može automatski otkazati porudžbinu u skladu sa pravilom prikazanim korisniku tokom procesa poručivanja.`}</S>

        <S n="6" title="PREUZIMANJE PORUDŽBINE">{`Ponesi je namenjen ličnom preuzimanju porudžbine u izabranom restoranu.

Porudžbini se dodeljuje javni broj porudžbine u formatu kao što je:

AB7

Isti javni broj porudžbine prikazuje se kupcu i restoranu radi lakšeg identifikovanja porudžbine.

Javni broj porudžbine nije bezbednosni token i samo poznavanje tog broja ne daje pravo pristupa korisničkom nalogu ili podacima o porudžbini.`}</S>

        <S n="7" title="CENE">{`Cene proizvoda određuju restorani.

Korisniku se pre konačne potvrde porudžbine prikazuje ukupna cena.

Ako se cena proizvoda ili izabrane opcije promeni pre konačnog kreiranja porudžbine, Ponesi može zahtevati od korisnika da potvrdi novu cenu.

Važeće cene prilikom kreiranja porudžbine određuju se na osnovu aktuelnih podataka na serveru Ponesi-ja.

Podaci o ceni koji postoje samo u internet pregledaču korisnika nisu autoritativni.`}</S>

        <S n="8" title="PLAĆANJE">{`Dok Ponesi ne uvede drugačiji sistem, plaćanje se vrši u restoranu prilikom preuzimanja porudžbine, načinom plaćanja koji konkretni restoran podržava.

To može uključivati plaćanje gotovinom ili platnom karticom u restoranu.

Ako se u budućnosti omogući online plaćanje, dodatni uslovi i informacije o takvom načinu plaćanja biće prikazani korisniku.`}</S>

        <S n="9" title="DOSTUPNOST PROIZVODA">{`Restoran može u svakom trenutku promeniti raspoloživost proizvoda ili opcija.

Ako proizvod više nije dostupan u trenutku konačnog kreiranja porudžbine, Ponesi može sprečiti poručivanje tog proizvoda.

Činjenica da je proizvod prethodno dodat u korpu ne garantuje njegovu kasniju dostupnost.

Ponesi će nastojati da korisnika jasno obavesti o takvoj promeni.`}</S>

        <S n="10" title="RADNO VREME I DOSTUPNOST RESTORANA">{`Restoran može biti označen kao otvoren, zatvoren, pauziran ili privremeno nedostupan za nove porudžbine.

Restoran može koristiti režim gužve koji utiče na najranije moguće vreme preuzimanja.

Ponesi ne garantuje da će restoran u svakom trenutku moći da primi novu porudžbinu.`}</S>

        <S n="11" title="OTKAZIVANJE">{`Mogućnost otkazivanja zavisi od statusa porudžbine i od toga da li je restoran već započeo pripremu.

Kod robe pripremljene prema konkretnom zahtevu korisnika, robe sa kratkim rokom trajanja ili robe koja je podložna brzom kvarenju mogu se primenjivati zakonski izuzeci od prava na odustanak.

Ništa u ovim Uslovima ne ograničava prava potrošača koja korisniku pripadaju prema prinudnim propisima Republike Srbije.`}</S>

        <S n="12" title="ALERGENI I INFORMACIJE O HRANI">{`Informacije o sastojcima, alergenima, načinu pripreme i proizvodima na Ponesi platformi dostavljaju restorani.

Korisnik sa alergijom, intolerancijom ili posebnim prehrambenim zahtevom treba da se neposredno obrati restoranu kada mu je potrebna dodatna potvrda u vezi sa sastojcima ili mogućom unakrsnom kontaminacijom.

Ponesi ne garantuje da proizvod ne sadrži određeni alergen osim ako za takvu garanciju postoji odgovarajuća zakonska i činjenična osnova.`}</S>

        <S n="13" title="ODGOVORNOST RESTORANA">{`Restoran odgovara za sopstvenu ponudu i izvršenje porudžbine, uključujući naročito:
- kvalitet hrane;
- higijensku i zdravstvenu ispravnost;
- količinu;
- pripremu;
- sastojke;
- alergene;
- tačnost informacija koje restoran dostavlja;
- raspoloživost proizvoda;
- izvršenje prihvaćene porudžbine;
- obaveze koje kao trgovac ima prema potrošaču.

Ova odredba ne isključuje odgovornost Sahara Group DOO za sopstveno postupanje ili obaveze koje Ponesi ima prema važećim propisima.`}</S>

        <S n="14" title="REKLAMACIJE I PODRŠKA">{`Za pitanja koja se odnose na samu hranu, količinu, pripremu ili uslugu konkretnog restorana korisnik može da se obrati tom restoranu.

Za tehničke probleme u vezi sa platformom Ponesi korisnik može da se obrati Sahara Group DOO na:

privacy@ponesi.rs

Ponesi može, kada je to potrebno i dozvoljeno, pomoći u razmeni relevantnih informacija između korisnika i restorana radi rešavanja problema.`}</S>

        <S n="15" title="ZABRANJENA UPOTREBA">{`Nije dozvoljeno:
- kreiranje lažnih ili zlonamernih porudžbina;
- pokušaj pristupa tuđem korisničkom nalogu;
- pokušaj pristupa podacima drugog restorana ili korisnika bez ovlašćenja;
- manipulisanje cenama ili zahtevima prema serveru;
- ometanje rada Platforme;
- zloupotreba automatizovanih sistema;
- korišćenje Ponesi-ja protivno zakonu.

Ponesi može privremeno ili trajno ograničiti pristup korisniku koji zloupotrebljava Platformu.`}</S>

        <S n="16" title="DOSTUPNOST PLATFORME">{`Ponesi nastoji da Platforma bude dostupna i pouzdana.

Međutim, nije moguće garantovati neprekidan rad bez tehničkih prekida.

Na funkcionisanje mogu uticati održavanje sistema, internet konekcija, infrastruktura, problemi eksternih pružalaca usluga ili drugi tehnički događaji.`}</S>

        <S n="17" title="INTELEKTUALNA SVOJINA">{`Naziv Ponesi, logo, dizajn, softver i drugi sadržaji čiji je nosilac prava Sahara Group DOO ili njegov davalac licence zaštićeni su odgovarajućim pravima.

Sadržaj koji restorani postavljaju na Platformu ostaje predmet prava odgovarajućeg restorana ili drugog nosioca prava.`}</S>

        <S n="18" title="IZMENE USLOVA">{`Ponesi može povremeno menjati ove Uslove radi razvoja Platforme, promena poslovnog modela ili usklađivanja sa propisima.

Kod značajnih promena korisnik može biti obavešten i od njega može biti zatraženo da prihvati novu verziju Uslova pre naredne porudžbine.`}</S>

        <S n="19" title="MERODAVNO PRAVO">{`Na ove Uslove primenjuju se propisi Republike Srbije.

Prava potrošača koja korisniku pripadaju na osnovu prinudnih propisa ne mogu biti isključena ovim Uslovima.

Za eventualne sporove primenjuju se pravila o nadležnosti utvrđena važećim propisima Republike Srbije.`}</S>

        <S n="20" title="KONTAKT">{`Sahara Group DOO
Masarikov Trg 18
16000 Leskovac, Republika Srbija
PIB: 115572837
MB: 22177460
Email:
privacy@ponesi.rs`}</S>

        <div className="mt-10 flex gap-3 text-sm">
          <a href="/politika-privatnosti" className="text-brand-red font-semibold underline" data-testid="link-to-privacy">Politika privatnosti</a>
          <a href="/" className="text-slate-500 font-semibold">Nazad na Ponesi</a>
        </div>
      </div>
    </div>
  );
}
